import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'
import { RootState } from '../rootState'

const initialState = {
  location: {
    path: '',
  },
}

interface LocationState {
  location: ReduxLocation
}

export interface ReduxLocation {
  path: string
}
const slice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    set: (state: LocationState, action: PayloadAction<ReduxLocation>) => {
      state.location = action.payload
    },
  },
})

export const useReduxLocation = (): ReduxLocation =>
  useSelector((state: RootState) => state.location.location)

export const LOCATION_STORE_NAME = slice.name
export const LocationActions = slice.actions
export default slice.reducer
